import { PaginationProps, TableProps } from 'antd';
import { getApi } from 'apis';
import { SideDrawerWrapper } from 'components/Global';
import ConfirmDelete from 'components/Global/confirmDeleteModel';
import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import AddUserBody from './AddDeviceBody';
import CustomTable from './CustomTable';
import styles from './index.module.scss';


const DeviceTable = () => {
	// State variables
	const [drawerAnimation, setDrawerAnimation] = useState<boolean>(false);
	const [isSideDrawerOpen, setSideDrawerOpen] = useState<boolean>(false);
	const [roleOptions, setRoleOptions] = useState([]);
	console.log(setRoleOptions);
	const [search, setSearch] = useState('');
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(
		Number(localStorage.getItem('deviceTableSize')) || 10
	);
	const [filter, setFilter] = useState('');
	const [sort, setSort] = useState('');
	const [type, setType] = useState('asc');
	const [drawerInfo, setDrawerInfo] = useState({
		drawerTitle: 'Device',
	});
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [editSelectedDevice, setEditSelectedDevice] = useState<any>();
	const [totalDevices, setTotalDevices] = useState(0);
	const [deviceData, setDeviceData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isDeleteLoading, setIsDeleteLoading] = useState<boolean>(false);
	const [isSearchCancel, setIsSearchCancel] = useState<boolean>(false);



	const removeDrawerFromDom = () => {
		setSideDrawerOpen(false);
	};

	const openDrawerHandler = () => {
		setDrawerInfo({ drawerTitle: 'Add Device' });
		setDrawerAnimation(true);
		setSideDrawerOpen(true);
	};


	const closeDrawerByAnimation = () => {
		setEditSelectedDevice(undefined); 
		setDrawerAnimation(false);
	};


	const performSearchHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setSearch(value);
		setPage(1);
		if(value.length > 0){
			setIsSearchCancel(true)
		}else{
			setIsSearchCancel(false)
		}
	};


	const showModal = () => {
		setIsModalOpen(true);
	};

	const setDrawerInfoHandler = (drawerTitle: any) => {
		setDrawerInfo({ drawerTitle });
	};

	const handleOk = () => {
		setIsModalOpen(false);
		setEditSelectedDevice(null);
	};

	const handleCancel = () => {
		setIsModalOpen(false); 
		setEditSelectedDevice(null);
	};

	// Delete device
	const deleteHandler = async () => {
		if (editSelectedDevice) {
			try {
				setIsDeleteLoading(true);
				// const resp = await deleteApiWithData('/user', { deleteUserId: editSelectedDevice.userCompanyRoleId });
				// toastText(resp?.data?.message ?? 'User deleted successfully', 'success');
			} catch (error: any) {
				toastText(error.response?.data?.message ?? 'Something went wrong in delete user', 'error');
			} finally {
				setIsDeleteLoading(false);
				handleCancel();
				fetchDevices();
			}
		}
	};

	const fetchDevices = useCallback(async () => {
		setIsLoading(true);
		const query = {
			page: page,
			limit: limit,
			search: search,
			sort: sort,
			type: type,
			filter: filter
		};
		const res = await getApi('/devices', query);
		setDeviceData(res?.data?.data);
		setIsLoading(false);
		setTotalDevices(res?.data?.total);
	}, [page, limit, search, type, sort, filter]);

	const handleTableChange: TableProps<any>['onChange'] = (
		pagination,
		filters,
		sorter
	) => {
		const sortOrder = Array.isArray(sorter)
			? sorter[0]?.order
			: sorter.order === 'ascend'
				? 'asc'
				: 'desc';
		setType(sortOrder as string);

		const sortField = Array.isArray(sorter)
			? sorter[0]?.field
			: sorter.field === 'name'
				? 'firstName'
				: sorter.field;
		setSort(sortField as string);
	};

	const onShowSizeChange: PaginationProps['onShowSizeChange'] = (
		current,
		pageSize
	) => {
		setPage(current);
		setLimit(pageSize);
	};

	useEffect(() => {
		fetchDevices();
	}, [limit, page, search, sort, type, filter]);

	// JSX
	return (
		<>
			<div className={styles['user-table']}>
				<CustomTable
					dataSource={deviceData}
					handleTableChange={handleTableChange}
					onShowSizeChange={onShowSizeChange}
					isLoading={isLoading}
					search={search}
					totalRecords={totalDevices}
					performSearchHandler={performSearchHandler}
					performFilterHandler={(value: any) => setFilter(value)}
					openDrawerHandler={openDrawerHandler}
					setDrawerInfoHandler={setDrawerInfoHandler}
					setEditSelectedDevice={setEditSelectedDevice}
					showModal={showModal}
					currentPage={page}
					pageSize={limit}
					isSearchCancel={isSearchCancel}
					setIsSearchCancel={setIsSearchCancel}
					setSearch={setSearch}
					fetchDevices={fetchDevices}
				/>
			</div>
			<ConfirmDelete
				handleCancel={handleCancel}
				handleOk={handleOk}
				isModalOpen={isModalOpen}
				deleteHandler={deleteHandler}
				isLoading={isDeleteLoading} //isLoading
			// isAddUserLoading={false} //isAddUserLoading
			/>
			{isSideDrawerOpen && (
				<SideDrawerWrapper
					isOpen={drawerAnimation}
					removeDrawerFromDom={removeDrawerFromDom}
					closeDrawerByAnimation={closeDrawerByAnimation}
					headerTitle={drawerInfo.drawerTitle}
					position="right"
					width="half"
				>
					<AddUserBody
						closeDrawerByAnimation={closeDrawerByAnimation}
						editSelectedDevice={editSelectedDevice}
						fetchDevices={fetchDevices}
						roleOptions={roleOptions}
					/>
				</SideDrawerWrapper>
			)}
		</>
	);
};

export default DeviceTable;
